export default __webpack_public_path__ + "static/media/island.f44a2b6e.png";